import {styled} from "@mui/material/styles";
import {Button, Stack} from "@mui/material";
import {SvgIconProps} from "@mui/material/SvgIcon";

export interface MapDrawToolButton {
    id: string;
    label: string;
    icon: React.FC<SvgIconProps>;
    onClick: () => void;
}

interface Props {
    activeButtonId: string;
    setActiveButtonId: React.Dispatch<React.SetStateAction<string>>;
    buttons: MapDrawToolButton[];
}

export const StyledButton = styled(Button)({
    boxShadow: "none",
    textTransform: "uppercase",
    fontWeight: 500,
    fontSize: 12,
    padding: "9px 9px",
    lineHeight: "normal",
    minWidth: "132px",
    "&:hover": {
        boxShadow: "none",
    },
});
export const ToggleButtons: React.FC<Props> = ({activeButtonId, setActiveButtonId, buttons}) => {
    const handleButtonClick = (id: string, onClick: () => void) => {
        setActiveButtonId(id);
        if (onClick) {
            onClick();
        }
    };

    return (
        <Stack direction="column" spacing={0}>
            {buttons.map((button) => (
                <StyledButton
                    key={button.id}
                    variant={activeButtonId === button.id ? "contained" : "outlined"}
                    color={activeButtonId === button.id ? "primary" : "secondary"}
                    startIcon={<button.icon sx={{color: activeButtonId ? "secondary" : "#8F94A8"}} />}
                    onClick={() => handleButtonClick(button.id, button.onClick)}
                    style={{
                        justifyContent: "flex-start",
                        width: "100%",
                        borderRadius: "0px",
                        backgroundColor: activeButtonId === button.id ? undefined : "#DBDEE6", // Default or active color is not set here
                        color: activeButtonId === button.id ? undefined : "#2B303F", // Text color when not active
                    }}
                >
                    {button.label}
                </StyledButton>
            ))}
        </Stack>
    );
};
